import OrderMatterportApi from '../OrderMatterportApi';

export function deleteLink(id) {
    return OrderMatterportApi.deleteMatterportLink(id);
}
